export default __webpack_public_path__ + "static/media/weather.17190ea9.png";